import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromFeatureReducer from './auth.reducer';

export const selectAuthState = createFeatureSelector<fromFeatureReducer.State>('auth');
export const getToken = createSelector(selectAuthState, fromFeatureReducer.getToken);
export const getLoggedIn = createSelector(selectAuthState, fromFeatureReducer.getLoggedIn);
export const getDidSucceed = createSelector(selectAuthState, fromFeatureReducer.getDidSucceed);
export const getProfile = createSelector(selectAuthState, fromFeatureReducer.getProfile);
